function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
/**
 * Access Script Templates for Stack Posts
 *
 * This module provides canonical access script templates that map publish intents
 * to deterministic access control scripts. Scripts operate on NFT properties, not
 * specific NFT IDs, allowing reusable subscription NFTs.
 *
 * All scripts are returned as JSON objects (not strings) for canonicalization.
 */

/**
 * Get access script template for a publish intent
 *
 * @param {Object} intent - Publish intent object
 * @param {string} intent.visibility - "public" | "private"
 * @param {string|null} intent.access_mode - null | "transferable" | "non-transferable"
 * @param {Object|null} intent.time_limit - null | { seconds: number }
 * @param {string} intent.author - Public key of the post author
 * @returns {Object|null} Access script object, or null for public posts
 */
function getAccessScriptForIntent(intent) {
  if (!intent || _typeof(intent) !== 'object') {
    throw new Error('getAccessScriptForIntent: intent must be an object');
  }

  // Validate intent structure
  if (!['public', 'private', 'subscription'].includes(intent.visibility)) {
    throw new Error("getAccessScriptForIntent: invalid visibility \"".concat(intent.visibility, "\""));
  }
  if (!intent.author || typeof intent.author !== 'string') {
    throw new Error('getAccessScriptForIntent: author must be a non-empty string');
  }

  // Public posts: no access script
  if (intent.visibility === 'public') {
    if (intent.access_mode !== null || intent.time_limit !== null) {
      throw new Error('getAccessScriptForIntent: public posts must have access_mode and time_limit as null');
    }
    return null;
  }

  // Private posts: select template based on access_mode
  if (intent.visibility === 'private') {
    var accessMode = intent.access_mode;
    if (accessMode === 'transferable') {
      return getPrivateTransferableScript(intent.author);
    } else if (accessMode === 'non-transferable') {
      return getPrivateNonTransferableScript(intent.author);
    } else if (accessMode === null) {
      // Default to transferable if not specified
      return getPrivateTransferableScript(intent.author);
    } else {
      throw new Error("getAccessScriptForIntent: invalid access_mode \"".concat(accessMode, "\""));
    }
  }

  // Subscription posts: select template based on access_mode
  if (intent.visibility === 'subscription') {
    var _accessMode = intent.access_mode;
    if (_accessMode === 'transferable') {
      return getSubscriptionTransferableScript(intent.author);
    } else if (_accessMode === 'non-transferable') {
      return getSubscriptionNonTransferableScript(intent.author);
    } else if (_accessMode === null) {
      // Default to transferable
      return getSubscriptionTransferableScript(intent.author);
    } else {
      throw new Error("getAccessScriptForIntent: invalid access_mode \"".concat(_accessMode, "\""));
    }
  }

  // Should never reach here
  throw new Error('getAccessScriptForIntent: unexpected intent state');
}

/**
 * Private + Transferable: CHECKOWNNFTWHERE script
 *
 * Validates:
 * - Submitter controls the NFT (via slips)
 * - NFT type === "stack"
 * - NFT creator === author public key
 *
 * @param {string} authorPublicKey - Public key of the post author
 * @returns {Object} Access script object
 */
function getPrivateTransferableScript(authorPublicKey) {
  return {
    op: 'CHECKOWNNFTWHERE',
    where: [{
      field: 'type',
      operator: '==',
      value: 'stack'
    }, {
      field: 'creator',
      operator: '==',
      value: authorPublicKey
    }]
  };
}

/**
 * Private + Non-Transferable: Chained constraints
 *
 * Validates:
 * - CHECKPATH: NFT ownership path
 * - CHECKPATHHOP: Delegation constraint (prevents transfer)
 * - CHECKOWNNFTWHERE: Type and creator validation
 *
 * @param {string} authorPublicKey - Public key of the post author
 * @returns {Object} Access script object
 */
function getPrivateNonTransferableScript(authorPublicKey) {
  return {
    op: 'AND',
    args: [{
      op: 'CHECKOWNNFTWHERE',
      where: [{
        field: 'type',
        operator: '==',
        value: 'stack'
      }, {
        field: 'creator',
        operator: '==',
        value: authorPublicKey
      }]
    }, {
      op: 'CHECKPATHHOP',
      selector: 'FIRST',
      where: [{
        field: 'value.delegate',
        operator: '==',
        value: false,
        type: 'boolean'
      }],
      assert: [{
        field: 'to',
        operator: '==',
        value: 'REQUESTER'
      }],
      publickey: authorPublicKey,
      hash: '__opcodes.checkownnftwhere.nft_id'
    }]
  };
}
function getSubscriptionTransferableScript(authorPublicKey) {
  return {
    op: 'AND',
    args: [{
      op: 'CHECKOWNNFTWHERE',
      where: [{
        field: 'type',
        operator: '==',
        value: 'stack'
      }, {
        field: 'creator',
        operator: '==',
        value: authorPublicKey
      }]
    }, {
      op: 'CHECKPATHHOP',
      selector: 'FIRST',
      where: [{
        field: 'value.delegate',
        operator: '==',
        value: false
      }],
      publickey: authorPublicKey,
      hash: '__opcodes.checkownnftwhere.nft_id'
    }, {
      op: 'IMPORTFIELD',
      field: 'duration',
      publickey: authorPublicKey,
      hash: '__opcodes.checkownnftwhere.nft_id'
    }, {
      op: 'SUMFIELDS',
      a: '__opcodes.checkpathhop.hop.value.timestamp',
      b: '__opcodes.importfield.duration',
      into: 'expiry'
    }, {
      op: 'CHECKFIELD',
      field: '__opcodes.sumfields.expiry',
      operator: '>',
      value: 'NOW'
    }]
  };
}
function getSubscriptionNonTransferableScript(authorPublicKey) {
  return {
    op: 'AND',
    args: [{
      op: 'CHECKOWNNFTWHERE',
      where: [{
        field: 'type',
        operator: '==',
        value: 'stack'
      }, {
        field: 'creator',
        operator: '==',
        value: authorPublicKey
      }]
    }, {
      op: 'CHECKPATHHOP',
      selector: 'FIRST',
      where: [{
        field: 'value.delegate',
        operator: '==',
        value: false
      }],
      publickey: authorPublicKey,
      hash: '__opcodes.checkownnftwhere.nft_id'
    }, {
      op: 'IMPORTFIELD',
      field: 'duration',
      publickey: authorPublicKey,
      hash: '__opcodes.checkownnftwhere.nft_id'
    }, {
      op: 'SUMFIELDS',
      a: '__opcodes.checkpathhop.hop.value.timestamp',
      b: '__opcodes.importfield.duration',
      into: 'expiry'
    }, {
      op: 'CHECKFIELD',
      field: '__opcodes.sumfields.expiry',
      operator: '>',
      value: 'NOW'
    }, {
      op: 'CHECKFIELD',
      field: '__opcodes.checkpathhop.hop.to',
      operator: '==',
      value: 'REQUESTER'
    }]
  };
}

/**
 * Embed witness data into a witness-free locking script.
 *
 * Returns a new script object; the original lockingScript is not mutated.
 *
 * @param {Object} lockingScript - Witness-free locking script object
 * @param {Object} witnessByOpcode - Witness payloads keyed by opcode name
 * @returns {Object} Complete access script with embedded witness
 */
function embedWitnessInScript(lockingScript, witnessByOpcode) {
  if (!lockingScript || _typeof(lockingScript) !== 'object') {
    throw new Error('embedWitnessInScript: lockingScript must be an object');
  }
  if (!witnessByOpcode || _typeof(witnessByOpcode) !== 'object') {
    throw new Error('embedWitnessInScript: witnessByOpcode must be an object');
  }
  function walk(node) {
    var copy = _objectSpread({}, node);
    var op = copy.op;
    if (op === 'AND' && Array.isArray(copy.args)) {
      copy.args = copy.args.map(function (child) {
        return walk(child);
      });
      return copy;
    }
    if (witnessByOpcode[op]) {
      copy.witness = _objectSpread(_objectSpread({}, copy.witness || {}), witnessByOpcode[op]);
    }
    return copy;
  }
  return walk(lockingScript);
}
module.exports = {
  getAccessScriptForIntent: getAccessScriptForIntent,
  embedWitnessInScript: embedWitnessInScript
};